"use client"
import { HoverEffect } from "@/components/ui/card-hover-effect";
import { motion, useInView } from "framer-motion";
import Link from "next/link";
// import React, { useRef,  } from "react";
import { useSelector } from "react-redux";

export function Blogs() {
  const { users } = useSelector((state) => state.user);
  // const ref = useRef(null);
  // const isInView = useInView(ref, { once: true });
  return (
    <div className="w-full min-h-screen bg-gradient-to-b from-[#020617] via-[#020617] to-[#0f172a] ">
      <div className="max-w-7xl mx-auto px-4 py-16">

        {/* HEADING */}
        <motion.h1
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-4xl md:text-6xl font-bold text-center py-4 bg-gradient-to-r from-white via-gray-300 to-gray-500 text-transparent bg-clip-text"
        >
          Innovating the Future Today
        </motion.h1>

        {/* DESCRIPTION */}
        <motion.p
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-6 text-gray-400 text-center max-w-2xl mx-auto leading-relaxed"
        >
          Discover insights, trends, and innovations shaping the future of
          technology. From AI to cloud computing — stay ahead with our expert
          content.
        </motion.p>

        {/* ADMIN BUTTON */}
        {users?.data.role === "Admin" && (
          <div className="flex justify-center mt-6">
            <Link href="/Addblogs">
              <button className="px-6 py-2 rounded-lg bg-gradient-to-r from-[#135C95] to-[#0ea5e9] hover:scale-105 transition shadow-lg">
                + Add Blog
              </button>
            </Link>
          </div>
        )}

        {/* BLOG CARDS */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="mt-14"
        >
          <HoverEffect />
        </motion.div>
      </div>
    </div>
  );
}
